import { root, BrowserStorage } from '@estee/elc-universal-utils';
import { IResponse } from '@estee/elc-http-transport';
import { Api, IConfig } from '@estee/elc-service';

import { RpcMethods } from './rpc-methods/RpcMethods';
import { IPGResponse, IToken } from './IJsonRpcApi';

const BASE_API_PATH = '/rpc/jsonrpc.tmpl';
const CSRF_TOKEN = 'csrftoken';
const METHOD_TYPE = 'dgbmethod';

export interface IJsonRpcDefaultHeaders {
    'content-type'?: string;
    Host?: string;
}

interface IJsonRPCApiFetch {
    method: string;
    headers?: {};
    body?: {};
    url?: string;
    methodType?: string;
}

export class JsonRPCApi extends Api {
    protected baseUrl: string;
    protected csrfToken;

    constructor(config: IConfig, serviceName: string, serviceVersion: string) {
        super(config, serviceName, serviceVersion);
        this.baseUrl = JsonRPCApi.getBaseUrl();
        this.csrfToken = this.getCsrfToken();
    }

    protected fetch = async ({
        method,
        headers,
        body,
        url,
        methodType
    }: IJsonRPCApiFetch): Promise<IResponse<IPGResponse[]>> => {
        const rpcMethodType = methodType ? methodType : METHOD_TYPE;
        const requestUrl = url ? url : this.generateUrl(method, rpcMethodType);
        const combinedHeaders = {
            ...JsonRPCApi.getHeaders(),
            ...(headers || {})
        };

        const response = await this.httpTransport.post({
            url: requestUrl,
            headers: combinedHeaders,
            body
        });

        return response as IResponse<IPGResponse[]>;
    };

    private generateUrl = (method: string, methodType: string) =>
        `${this.baseUrl + BASE_API_PATH}?${methodType}=${method}`;

    private static getHeaders = () => {
        const headers: IJsonRpcDefaultHeaders = {};
        headers['content-type'] = 'application/x-www-form-urlencoded; charset=UTF-8';

        return headers;
    };

    private static getBaseUrl = (): string => {
        return `${root.location.protocol}//${root.location.host}`;
    };

    private getCsrfToken = () => {
        const cookieCsrfToken = BrowserStorage.getCookie(CSRF_TOKEN);

        return cookieCsrfToken ? cookieCsrfToken : this.fetchCsrfToken();
    };

    private fetchCsrfToken = async () => {
        const method = RpcMethods.GET_TOKEN_METHOD;
        const { data }: IResponse<IPGResponse[]> = await this.fetch({
            method,
            body: this.formatToRPC(method, [])
        });

        const { token }: IToken = data?.[0].result?.value as IToken;

        return token;
    };

    protected formatToRPC = (method: string, payload: unknown = {}) => {
        const boilerplate = [
            {
                method,
                params: payload
            }
        ];
        const data = new URLSearchParams();
        data.append('JSONRPC', JSON.stringify(boilerplate));

        return data;
    };
}
